import CardWrapper from "components/commons/cardWrapper/CardWrapper";
import React, { useState } from "react";
import styles from "../../../selectAdSpot/SelectAdSpot.module.scss";
import { strings } from "intl/fa";
import { Button, ButtonSize, Success, TextField } from "@bale/ui";
import {
  GeneralErrors,
  GeneralValidators,
  useInputHandler,
} from "hooks/useInputHandler";
import { useAppDispatch } from "utils/store";
import { NavigationActions, AppPage } from "core/navigation/navigation.slice";
import Footer from "components/commons/footer/Footer";
import { useRequest } from "hooks/useRequest";
import { submitBusinessAdOrderThunk } from "core/orderAd/orderAd.thunk";
import NotifModal from "components/commons/modal/notifModal/NotifModal";
import { AdSpot, BusinessAdSpot } from "core/orderAd/orderAd.entity";
import { digitsToHindi, digitsToLatin } from "@bale/utils";
import { GetMemberCountThunk } from "core/membersCount/membersCount.thunk";
import { toast } from "react-toastify";
import { formatStrings } from "utils/utils";
import { ONBOARDING_ORDER_MIN_MEMBERCOUNT } from "utils/constants";

type Props = {
  adSpot: BusinessAdSpot;
};
const ContactInfoForm: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const dispatch = useAppDispatch();

  const { sendRequest: submitBusinessAdOrder } = useRequest(
    submitBusinessAdOrderThunk
  );
  const { sendRequest: getmemberCount } = useRequest(GetMemberCountThunk);
  const businessNameInputHandler = useInputHandler({
    rules: [GeneralValidators.required],
    errorMessages: {
      [GeneralErrors.Required]: strings.common.error.required,
    },
  });
  const channelIdInputHandler = useInputHandler({
    rules: [GeneralValidators.required],
    errorMessages: {
      [GeneralErrors.Required]: strings.common.error.required,
    },
  });
  const mobileNumInputHandler = useInputHandler({
    numberOnly: true,
    rules: [GeneralValidators.required, GeneralValidators.phone],
    errorMessages: {
      [GeneralErrors.Required]: strings.common.error.required,
      [GeneralErrors.Phone]: strings.login.phone.error,
    },
  });

  const inputsAreValid = Boolean(
    (businessNameInputHandler.rawValue.trim() &&
      mobileNumInputHandler.rawValue) ||
      (channelIdInputHandler.rawValue.trim() && mobileNumInputHandler.rawValue)
  );

  const submitHandler = async () => {
    if (inputsAreValid) {
      await getmemberCount({
        link: channelIdInputHandler.rawValue.trim(),
        onSuccess(res: any) {
          if (res.count < ONBOARDING_ORDER_MIN_MEMBERCOUNT) {
            toast.info(
              formatStrings(
                strings.dialog_ad_form.select_ad_type.minimum_members,
                {
                  count: digitsToHindi(
                    String(ONBOARDING_ORDER_MIN_MEMBERCOUNT)
                  ),
                }
              )
            );
            return;
          }
          submitBusinessAdOrder({
            name: businessNameInputHandler.rawValue,
            phone_no: digitsToLatin(mobileNumInputHandler.rawValue),
            link: channelIdInputHandler.rawValue,
            spot: props.adSpot,
            onSuccess: () => setShowSuccessModal(true),
          });
        },
      });
    }
  };

  return (
    <>
      <div className={styles.Content}>
        <CardWrapper className={styles.Card}>
          <div className={styles.Description}>
            {strings.dialog_ad_form.select_ad_type.order_ad_info}
          </div>
          {props.adSpot === AdSpot.AdSpotMyBank && (
            <TextField
              {...businessNameInputHandler}
              placeholder={
                strings.dialog_ad_form.select_ad_type.business_name_placeHolder
              }
              label={strings.dialog_ad_form.select_ad_type.business_name}
              dir="rtl"
            />
          )}
          {props.adSpot === AdSpot.AdSpotOnBoarding && (
            <TextField
              {...channelIdInputHandler}
              placeholder={
                strings.dialog_ad_form.select_ad_type.channel_id_placeHolder
              }
              label={strings.dialog_ad_form.select_ad_type.channel_id}
            />
          )}
          <TextField
            {...mobileNumInputHandler}
            placeholder={
              strings.dialog_ad_form.select_ad_type.mobile_num_placeHolder
            }
            label={strings.dialog_ad_form.select_ad_type.mobile_num}
          />
        </CardWrapper>
      </div>
      <Footer>
        <Button
          text={strings.common.button.submit_request}
          size={ButtonSize.Medium}
          onClick={submitHandler}
          disable={!inputsAreValid}
        />
      </Footer>
      {showSuccessModal && (
        <NotifModal
          title={strings.dialog_ad_form.select_ad_type.modal_success_header}
          onClose={() => {}}
          icon={<Success size={50} />}
          primaryButton={{
            label: strings.common.button.understood,
            onClick: () => {
              dispatch(NavigationActions.setAppPage(AppPage.OrdersList));
            },
          }}
          content={strings.dialog_ad_form.select_ad_type.modal_success_desc}
        />
      )}
    </>
  );
};

export default ContactInfoForm;
